<template>
  <div>
    <div class="w-full flex mb-4">
      <report-date-picker v-model="dateRange" @change="getReports"/>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 grid-cols-3 gap-4">
      <stats-card :title="clientKpis.orders | toCurrency"
                  :loading="loading"
                  class="col-span-1"
                  :small-title="$t('generic.sales')"
                  type="info"
                  icon="nc-icon nc-chart-pie-36">
      </stats-card>

      <stats-card :title="clientKpis.jobs"
                  :loading="loading"
                  class="col-span-1"
                  :small-title="$t('generic.jobs')"
                  type="warning"
                  icon="nc-icon nc-briefcase-24">
      </stats-card>
      <stats-card :title="clientKpis.credits"
                  :loading="loading"
                  class="col-span-1"
                  :small-title="$t('generic.credits')"
                  type="success"
                  icon="nc-icon nc-money-coins">
      </stats-card>
      <stats-card :title="clientKpis.applicants"
                  :loading="loading"
                  class="col-span-1"
                  :small-title="$t('generic.applicants')"
                  type="info"
                  icon="nc-icon nc-paper">
      </stats-card>
    </div>
    <client-order-history-report :date-from="dateFrom" :date-till="dateTill"/>
  </div>
</template>
<script>
import get from 'lodash/get'
import StatsCard from '@/components/Cards/StatsCard'
import ReportService from '@/services/ReportService'
import ReportDatePicker from '@/views/admin/reports/ReportDatePicker'
import ClientOrderHistoryReport from '@/views/admin/reports/ClientOrderHistoryReport'
import { getDefaultRange } from '@/views/admin/reports/defaultReportRange'
import ClientService from "@/services/ClientService";

export default {
  name: 'client-management-dashboard',
  components: {
    StatsCard,
    ReportDatePicker,
    ClientOrderHistoryReport,
  },
  data () {
    const year = new Date().getFullYear()
    const defaultRange = getDefaultRange()
    return {
      year,
      defaultRange,
      dateRange: [...defaultRange],
      loading: false,
      clientKpis: {
        applicants: 0,
        apply_start: 0,
        click_out: 0,
        credits: 0,
        jobs: 0,
        orders: 0,
        views: 0,
      }
    }
  },
  computed: {
    dateFrom () {
      return get(this.dateRange, '[0]', this.defaultRange[0])
    },
    dateTill () {
      return get(this.dateRange, '[1]', this.defaultRange[1])
    },
  },
  methods: {
    async getReports () {
      try {
        this.loading = true
        await this.getClientKpis()
      } finally {
        this.loading = false
      }
    },
    async getClientKpis() {
      const clientUuid = this.$route.params.id
      const range = `${this.dateFrom},${this.dateTill}`
      const { data } = await ClientService.getKpi(clientUuid, range)
      this.clientKpis = data
    }
  },
  mounted () {
    this.getReports()
  }
}
</script>
